import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import {
  Grid,
  Button
} from "@mui/material";
import { useReactToPrint } from "react-to-print";
import Topbar from "../global/Topbar";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Pagination from '@mui/material/Pagination';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { ToastContainer, toast } from 'react-toastify';

function AcGroupMaster(props) {
  const [acGroups, setAcGroups] = useState([]);
  const [AcGroupCode, setAcGroupCode] = useState('');
  const [AcGroupName, setAcGroupName] = useState('');
  const [AcGroupNameEng, setAcGroupNameEng] = useState('');
  const [AcGroupType, setAcGroupType] = useState('');
  const [AcGroupPrintPosition, setAcGroupPrintPosition] = useState('');
  const [DeptCode, setDeptCode] = useState('');
  const [YearCode, setYearCode] = useState('');
  const [UserID, setUserID] = useState('');
 
  const [errorMessage, setErrorMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [currentItems, setCurrentItems] = useState([]);
 
  const [deleteEntryNo, setDeleteEntryNo] = useState(null);
  const [openConfirmation, setOpenConfirmation] = useState(false);  

  const [formMode, setFormMode] = useState('add');
  const [editAcGroupCode, setEditAcGroupCode] = useState(null);
  const [showGrid, setShowGrid] = useState(true);
  const [acGroupMasterEntries, setAcGroupMasterEntries] = useState([]);

  useEffect(() => {
    fetchAcGroupMaster();
  }, []);

  const fetchAcGroupMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/acgroups');
      setAcGroupMasterEntries(response.data);
      const maxEntryNo = calculateMaxEntryNo(response.data);
      const nextEntryNo = maxEntryNo + 1;
      setAcGroupCode(nextEntryNo);
      //console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const calculateMaxEntryNo = (entries) => {
    let maxEntryNo = 0;
    for (const entry of entries) {
      if (entry.AcGroupCode > maxEntryNo) {
        maxEntryNo = entry.AcGroupCode;
      }
    }
    return maxEntryNo;
  };

  const addAcGroup = async () => {
    try {
      await axios.post('https://www.wingap.net.in/api/acgroups', {
        AcGroupCode,
        AcGroupName,
        AcGroupNameEng,
        AcGroupType,
        AcGroupPrintPosition,
        DeptCode,
        YearCode,
        USERID: props.name
      });
      fetchAcGroupMaster();
      setAcGroupCode('');
      setAcGroupName('');
      setAcGroupNameEng('');
      setAcGroupType('');
      setAcGroupPrintPosition('');
      setDeptCode('');
      setYearCode('');
      setUserID('');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const updateAcGroup = async (AcGroupCode) => {
    try {
      await axios.put(`https://www.wingap.net.in/api/acgroups/${AcGroupCode}`, {
        AcGroupCode,
        AcGroupName,
        AcGroupNameEng,
        AcGroupType,
        AcGroupPrintPosition,
        DeptCode,
        YearCode,
        USERID: props.name
      });
      fetchAcGroupMaster();
      setAcGroupCode('');
      setAcGroupName('');
      setAcGroupNameEng('');
      setAcGroupType('');
      setAcGroupPrintPosition('');
      setDeptCode('');
      setYearCode('');
      setUserID('');
      setFormMode('add');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const handleDeleteConfirmation = async () => {
    try {
      if (deleteEntryNo) {
        await deleteAcGroup(deleteEntryNo.AcGroupCode);
        setOpenConfirmation(false);
      }
    } catch (error) {
      console.log('Error:', error);
    }
  };
  

  const deleteAcGroup = async (AcGroupCode) => {
    if (!props.canDelete) {
              toast.error("You do not have permission to Delete.", { autoClose: 800 });
              return;
            }
    try {
      const response = await axios.delete(`https://www.wingap.net.in/api/acgroups/${AcGroupCode}`, {
        headers: {
          'username': props.name,
        },
      });

      if (response.status === 200) {
        fetchAcGroupMaster();
      }
    } catch (error) {
      console.log('Error:', error);

      if (error.response && error.response.status === 403) {
        // User does not have permission to delete account group
        setErrorMessage('Permission Denied');
        setSnackbarOpen(true);
      } else {
        // Handle other errors if needed
        setErrorMessage('An error occurred while deleting the account group. Please try again later.');
        setSnackbarOpen(true);
        // Alternatively, you can log the detailed error to the console for debugging
        console.error('Error:', error);
      }
    }
  };

  const handleCloseSnackbar = () => {
    // Close the Snackbar
    setSnackbarOpen(false);
    // Reset the error message
    setErrorMessage('');
  };  

  const setEditForm = (acGroup) => {
    setFormMode('edit');
    setAcGroupCode(acGroup.AcGroupCode);
    setAcGroupName(acGroup.AcGroupName);
    setAcGroupNameEng(acGroup.AcGroupNameEng);
    setAcGroupType(acGroup.AcGroupType);
    setAcGroupPrintPosition(acGroup.AcGroupPrintPosition);
    setDeptCode(acGroup.DeptCode);
    setYearCode(acGroup.YearCode);
    setUserID(acGroup.UserID);
    setShowGrid(false);
  };

  const handleSearch = (searchQuery) => {
    const filtered = acGroups.filter((acGroup) => {
      const AcGroupCode = acGroup.AcGroupCode.toString().toLowerCase();
      const AcGroupName = acGroup.AcGroupName.toString().toLowerCase();
      const AcGroupNameEng = acGroup.AcGroupNameEng.toString().toLowerCase();
      const AcGroupType = acGroup.AcGroupType.toString().toLowerCase();
      const AcGroupPrintPosition = acGroup.AcGroupPrintPosition.toString().toLowerCase();
      const DeptCode = acGroup.DeptCode.toString().toLowerCase();
      const YearCode = acGroup.YearCode.toString().toLowerCase();
      const UserID = acGroup.UserID.toString().toLowerCase();

      return (
        AcGroupCode.includes(searchQuery.toLowerCase()) ||
        AcGroupName.includes(searchQuery.toLowerCase()) ||
        AcGroupNameEng.includes(searchQuery.toLowerCase()) ||
        AcGroupType.includes(searchQuery.toLowerCase()) ||
        AcGroupPrintPosition.includes(searchQuery.toLowerCase()) ||
        DeptCode.includes(searchQuery.toLowerCase()) ||
        YearCode.includes(searchQuery.toLowerCase()) ||
        UserID.includes(searchQuery.toLowerCase())
      );
    });

    setAcGroupMasterEntries(filtered);
  };

  useEffect(() => {
    handleSearch(props.searchQuery);
  }, [props.searchQuery, acGroups]);

  const handleshowandhide = () => {
    setShowGrid(!showGrid);
    setAcGroups(acGroups);
  };

  const handleCancel = () => {
    setFormMode('add');
    setEditAcGroupCode('');
    setAcGroupCode('');
    setAcGroupName('');
    setAcGroupNameEng('');
    setAcGroupType('');
    setAcGroupPrintPosition('');
    setDeptCode('');
    setYearCode('');
    setUserID('');
    fetchAcGroupMaster();
  };

  const componentPDF = useRef();

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "AcGroupData",
    onAfterPrint: () => alert("Pdf downloaded"),
    pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }
        
        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
  });

  useEffect(() => {
    if (acGroupMasterEntries.length > 0) {
      const indexOfLastItem = currentPage * itemsPerPage;
      const indexOfFirstItem = indexOfLastItem - itemsPerPage;
      const newCurrentItems = acGroupMasterEntries.slice(indexOfFirstItem, indexOfLastItem);
      setCurrentItems(newCurrentItems);
    }
    else {
      setCurrentItems([]);
    }
  }, [acGroupMasterEntries, currentPage, itemsPerPage]);

  const handleChangePage = (event, page) => {
    setCurrentPage(page);
  };

  return (
    <div style={{ maxWidth: '100%', margin: '0 auto', padding: '20px' }}>
      <ToastContainer/>
      <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>Account Group Master</h1>
      <Grid item>
        <Button
          variant="contained"
          className="view-button"
          onClick={handleshowandhide}
          sx={{ backgroundColor: showGrid ? '#4caf50' : 'blue', color: "white", marginBottom: "20px", float: 'right' }}
        >
          {showGrid ? 'Add' : 'Back'}
        </Button>
      </Grid>
      {showGrid && <Grid item>
        <Button
          variant="contained"
          onClick={generatePDF}
          sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
        >
          Download PDF
        </Button>
      </Grid>}
      {showGrid && <Grid item>
        <Button
          variant="contained"
          sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
        >
          Export
        </Button>
      </Grid>}
      {!showGrid && (
        <>
        <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>{formMode === 'add' ? 'Add' : 'Edit'}</h2>
        <div style={{ fontSize: '16px',display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center'}}>
            <label htmlFor="AcGroupCode" style={{ width: '150px', marginRight: '10px' }}>GroupCode</label>
            <input
              type="text"
              value={AcGroupCode}
              readOnly
              placeholder="AcGroupCode"
              style={{ padding: '5px',width:'10%'}}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="AcGroupName" style={{ width: '150px', marginRight: '10px' }}>GroupName</label>
            <input
              type="text"
              value={AcGroupName}
              onChange={(e) => setAcGroupName(e.target.value)}
              placeholder="AcGroupName"
              style={{ padding: '5px',width:'50%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="AcGroupNameEng" style={{ width: '150px', marginRight: '10px' }}>AcGroupNameEng</label>
            <input
              type="text"
              value={AcGroupNameEng}
              onChange={(e) => setAcGroupNameEng(e.target.value)}
              placeholder="AcGroupNameEng"
              style={{ padding: '5px',width:'50%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="AcGroupType" style={{ width: '150px', marginRight: '10px' }}>AcGroupType</label>
            <select
              value={AcGroupType}
              onChange={(e) => setAcGroupType(Number(e.target.value))}
              style={{ marginBottom: '5px', padding: '5px' ,width:'20%'}}
            >
              <option value={0}>Manufacturing</option>
              <option value={1}>Trading</option>
              <option value={2}>Profit And Loss</option>
              <option value={3}>Balance Sheet</option>
            </select>
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="AcGroupPrintPosition" style={{ width: '150px', marginRight: '10px' }}>AcGroupPrintPosition</label>
            <input
              type="text"
              value={AcGroupPrintPosition}
              onChange={(e) => setAcGroupPrintPosition(e.target.value)}
              placeholder="AcGroupPrintPosition"
              style={{ padding: '5px',width:'10%' }}
            />
          </div>
          
        </div>
        <div>
          <button
            className={formMode === 'add' ? 'add-button' : 'update-button'}
            onClick={formMode === 'add' ? addAcGroup : () => updateAcGroup(AcGroupCode)}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: formMode === 'add' ? '#4caf50' : '#2196f3',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              marginBottom: '10px',
            }}
          >
            {formMode === 'add' ? 'Add' : 'Update'}
          </button>
          <button
            className="view-button"
            onClick={handleCancel}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: '#f44336',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              marginLeft: '10px',
              marginBottom: '10px',
            }}
          >
            Cancel
          </button>
        </div>
      </>
      )}
      {showGrid && (
        <div ref={componentPDF} style={{ width: '100%' }}>
          <h2>Entries</h2>
          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              border: '1px solid #ccc',
            }}
          >
            <thead>
              <tr style={{ background: '#f2f2f2', color: 'black' }}>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  GroupCode
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  GroupName
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  GroupNameEng
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  GroupType
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  GroupPrintPosition
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                  className="print-hide"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((acGroup) => (
                <tr key={acGroup.AcGroupCode} style={{ backgroundColor: 'white', color: 'black', textAlign: 'center' }}>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{acGroup.AcGroupCode}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{acGroup.AcGroupName}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{acGroup.AcGroupNameEng}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{acGroup.AcGroupType}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{acGroup.AcGroupPrintPosition}</td>
                  <td className="print-hide">
                    <button
                      style={{
                        padding: '5px 10px',
                        backgroundColor: 'rgb(76, 175, 80)',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                        marginRight: '5px',
                        marginLeft: '10px',
                      }}
                      onClick={() => setEditForm(acGroup)}
                    >
                      Edit
                    </button>
                    <button
                      style={{
                        padding: '5px 10px',
                        backgroundColor: 'rgb(244, 67, 54)',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        setDeleteEntryNo({AcGroupCode: acGroup.AcGroupCode});
                        setOpenConfirmation(true); 
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <Stack spacing={2} style={{ marginTop: '10px', textAlign: 'center', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Pagination
              count={Math.ceil(acGroupMasterEntries.length / itemsPerPage)} 
              page={currentPage}
              onChange={handleChangePage}
              color="primary"
              showFirstButton
              showLastButton
            />
          </Stack>

          <Dialog
            open={openConfirmation}
            onClose={() => setOpenConfirmation(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Confirm Delete"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to DELETE ?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenConfirmation(false)} color="inherit">
                Cancel
              </Button>
              <Button onClick={() => handleDeleteConfirmation()} color="error" autoFocus>
                DELETE
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}

      {/* Snackbar for displaying error messages */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'center', horizontal: 'center'}} // Center the Snackbar
      >
        <MuiAlert elevation={6} variant="filled" severity="error" sx={{fontSize:'16px'}} onClose={handleCloseSnackbar}>
          {errorMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
}

export default AcGroupMaster;
